<script>
import Component from '~/sites/oknanebodvere/pages/_'
export default {
  extends: Component,
}
</script>
